import request from '@/utils/request';
const { VUE_APP_LAOSHIBANG } = process.env;

// 邀请码检测
export function checkCode(data) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/org/check_code',
    method: 'post',
    data
  });
}

// 加入学校
export function joinOrg(data) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/org/join',
    method: 'post',
    data
  });
}

// 获取校本题库链接
export function getTikuLink(data) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/org/tiku_link',
    method: 'post',
    data
  });
}

// 获取云盘链接
export function getDiskLink(data) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/org/disk_link',
    method: 'post',
    data
  });
}

// 获取云盘登录token
export function getDiskToken(data) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/org/disk_token',
    method: 'post',
    data
  });
}

// 记录用户当前机构
export function recordOrg(data) {
  return request({
    url: VUE_APP_LAOSHIBANG + '/v1/user/cur_org',
    method: 'post',
    data
  });
}